module.exports = __webpack_public_path__ + "static/img/app-2.b67e7df.png";


//////////////////
// WEBPACK FOOTER
// ./static/app-2.png
// module id = yiUn
// module chunks = 0